import { post } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface CustomShareEntityModel {
    emailFrom: string;
    emailTo: string;
    entityId: string;
    entityName: string;
    message: string;
    subject: string;
    type?: string;
}

const customShareEntityUrl = "/api/v2/Verizon/ShareEntity";
const orderDetailsShareEntityUrl = "/api/v2/orderhistory/ShareEntity";

export function submitCustomShareEntity(parameter: CustomShareEntityModel) {
    return post<CustomShareEntityModel>(`${customShareEntityUrl}`, parameter);
}
export function submitOrderDetailsShareEntity(parameter: CustomShareEntityModel) {
    return post<CustomShareEntityModel>(`${orderDetailsShareEntityUrl}`, parameter);
}
